module.exports = __webpack_public_path__ + "static/media/delivery_address.ac5a10d6.png";